import Spinner from './Spinner.jsx';
import EmptyState from './EmptyState.jsx';

export default function Table({ columns, data, loading, emptyMessage = 'Sin resultados', rowKey = 'id' }) {
  if (loading) {
    return <div className="flex justify-center py-8"><Spinner /></div>;
  }
  if (!data || data.length === 0) {
    return <EmptyState message={emptyMessage} />;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border text-left">
            {columns.map((col) => (
              <th key={col.key} className="px-3 py-2 font-medium text-text-muted">{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row[rowKey]} className="border-b border-border last:border-0 hover:bg-bg-elevated">
              {columns.map((col) => (
                <td key={col.key} className="px-3 py-2 text-text-secondary">
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
